import { combineReducers } from "redux"
import { buildings } from "@theguarantors/frontend-core/dist/features/buildings"

import { LGQuestionnaireStore } from "../types/store.types"
import noApartment from "./noApartment"
import unenrolledForm from "./unenrolledForm"

export const reducers = combineReducers<LGQuestionnaireStore>({
  buildings,
  noApartment,
  unenrolledForm
})
